import React, {useEffect, useState, Fragment} from "react";
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import {initReactI18next} from "react-i18next";
import {JSON_URL, LANGUAGE_PATH} from "modules/constants";
import {Preloader} from "components";

export const HOCi18n: React.FC = ({children}) => {
	const [initialized, setInitialized] = useState(false);

	useEffect(() => {
		i18n.use(LanguageDetector)
			.use(Backend)
			.use(initReactI18next)
			.init(
				{
					/**
					 * i18nextBrowserLanguageDetector
					 */
					detection: {
						order: ["path", "cookie", "localStorage", "sessionStorage", "navigator"],
						lookupFromPathIndex: 1,
					},
					ns: ["global", LANGUAGE_PATH],
					supportedLngs: ["en", "es", "fr", "de", "ar"],
					backend: {
						crossDomain: true,
						loadPath: `${JSON_URL}langs/{{ns}}/{{lng}}.json`,
					},
					fallbackLng: "en",
					debug: false, //ENV !== "production",
					keySeparator: ".",
					interpolation: {
						escapeValue: false,
						formatSeparator: ",",
					},
				},
				() => {
					document.dir = i18n.dir();
					setInitialized(true);
				}
			)
			.catch((err) => console.log(err));
	}, []);

	return initialized ? <Fragment>{children}</Fragment> : <Preloader />;
};
